var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.964,
    height: 103.908,
    id: "google-pay",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 51.954,
    cy: 51.954,
    r: 51.954,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e7bf2",
    d: "M51.954 103.908a51.716 51.716 0 0 1-27.331-7.76L59.423.533a51.954 51.954 0 0 1-7.473 103.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M34.331 51.726a11.01 11.01 0 0 0-.267-2.6H22.107v4.725h7.02a6.215 6.215 0 0 1-2.6 4.132l-.025.156 3.779 2.929.262.025a12.455 12.455 0 0 0 3.789-9.365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M22.107 64.178a12.144 12.144 0 0 0 8.434-3.085l-4.016-3.115a7.526 7.526 0 0 1-4.413 1.273 7.677 7.677 0 0 1-7.247-5.294l-.151.015-3.93 3.04-.05.141a12.694 12.694 0 0 0 11.373 7.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M14.86 53.964a7.8 7.8 0 0 1-.423-2.521 8.268 8.268 0 0 1 .413-2.521l-.005-.166-3.981-3.09-.131.06a12.706 12.706 0 0 0 0 11.433l4.127-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb4335",
    d: "M22.107 43.635a7.026 7.026 0 0 1 4.922 1.9l3.595-3.507a12.246 12.246 0 0 0-8.52-3.311 12.721 12.721 0 0 0-11.378 7.02l4.116 3.2a7.707 7.707 0 0 1 7.267-5.294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.375 52.86v9.254h-2.959V39.252h7.845a7.125 7.125 0 0 1 5.083 1.978 6.58 6.58 0 0 1 .377 9.3q-.181.2-.377.377a7.106 7.106 0 0 1-5.083 1.947l-4.886.005Zm0-10.794v7.981h4.957a3.979 3.979 0 0 0 3.029-6.663l-.03-.03a1.036 1.036 0 0 0-.076-.076 3.869 3.869 0 0 0-2.924-1.213Zm18.9 3.9a7.352 7.352 0 0 1 5.178 1.741 6.149 6.149 0 0 1 1.9 4.771v9.642h-2.828v-2.174h-.126a5.662 5.662 0 0 1-4.891 2.682 6.354 6.354 0 0 1-4.353-1.535 4.884 4.884 0 0 1-1.751-3.83 4.635 4.635 0 0 1 1.847-3.86 7.844 7.844 0 0 1 4.937-1.434 8.819 8.819 0 0 1 4.338.956v-.674a3.324 3.324 0 0 0-1.223-2.6 4.2 4.2 0 0 0-2.853-1.067 4.546 4.546 0 0 0-3.92 2.073l-2.6-1.63a7.226 7.226 0 0 1 6.351-3.065Zm-3.83 11.363a2.349 2.349 0 0 0 .976 1.917 3.62 3.62 0 0 0 2.3.765 4.712 4.712 0 0 0 3.326-1.374 4.28 4.28 0 0 0 1.469-3.226 6.084 6.084 0 0 0-3.86-1.1 5.016 5.016 0 0 0-3 .861 2.607 2.607 0 0 0-1.208 2.154Zm27.145-10.85-9.874 22.53h-3.055l3.664-7.886-6.5-14.654h3.216l4.7 11.237h.065l4.564-11.237Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.6de6fe88254093b8ed386f86aaeff810.svg";
export { ForwardRef as ReactComponent };